import { useTranslation } from 'react-i18next';
import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardHeaderRow,
  CardTitle,
  Stack,
  Text,
} from '@shared/ui';

export function CardShowcase() {
  const { t } = useTranslation();

  return (
    <Stack gap="md">
      <Card id="ui-card-static-example">
        <CardHeader>
          <CardTitle>{t('uiLibrary.layout.card.title')}</CardTitle>
          <CardDescription>{t('uiLibrary.layout.card.description')}</CardDescription>
        </CardHeader>
        <CardContent>
          <Stack gap="md">
            <Text>{t('uiLibrary.layout.card.content')}</Text>
            <div className="flex flex-col gap-2 sm:flex-row">
              <Button size="sm" className="w-full sm:w-auto">
                {t('uiLibrary.layout.card.primaryAction')}
              </Button>
              <Button size="sm" variant="outline" className="w-full sm:w-auto">
                {t('uiLibrary.layout.card.secondaryAction')}
              </Button>
            </div>
          </Stack>
        </CardContent>
        <CardFooter>
          <Text size="sm" color="muted">
            {t('uiLibrary.layout.card.footerNote')}
          </Text>
        </CardFooter>
      </Card>
      <Card
        role="link"
        aria-label={t('common.back')}
        onClick={() => {
          window.location.hash = 'ui-card-static-example';
        }}
      >
        <CardContent className="p-4">
          <CardHeaderRow>
            <CardTitle>{t('common.back')}</CardTitle>
          </CardHeaderRow>
        </CardContent>
      </Card>
    </Stack>
  );
}
